import { cn } from '@/lib/utils';
import { formatSeconds } from '@/utils/media/formatSeconds';
interface TimeProps {
  currentValue: number;
  maxValue: number;
}
const Time = ({
  currentValue,
  maxValue
}: TimeProps) => <span className="xs:flex hidden flex-row flex-nowrap justify-between whitespace-nowrap font-normal text-sm text-white" data-sentry-component="Time" data-sentry-source-file="Time.tsx">
    <span className={cn('mr-1 text-left', maxValue > 3600 ? 'w-12' : 'w-7')}>
      {formatSeconds(currentValue)}
    </span>
    {typeof maxValue === 'number' && <span>/ {formatSeconds(maxValue)}</span>}
  </span>;
export default Time;